type IconProps = React.ComponentProps<'svg'>

export function FlowsIconIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.48, 2.62)">
        <path
          d="M0.44516 0.44501c0.5936-0.59327 1.55689-0.59343 2.15039 0l8.35938 8.36035c0.5935 0.5935 0.59329 1.55579 0 2.14942l-8.35938 8.36035c-0.5936 0.5936-1.55679 0.5936-2.15039 0-0.59327-0.5935-0.59318-1.55586 0-2.14942l7.28516-7.28613-7.28516-7.28418c-0.59353-0.5936-0.59357-1.55682 0-2.15039z m9 0c0.5936-0.59327 1.55689-0.59343 2.15039 0l8.35938 8.36035c0.28497 0.28497 0.44521 0.6722 0.44531 1.0752-0.00009 0.40286-0.16053 0.78928-0.44531 1.07422l-8.35938 8.36035c-0.5936 0.5936-1.55679 0.5936-2.15039 0-0.59328-0.5935-0.59318-1.55586 0-2.14942l7.28516-7.28613-7.28516-7.28418c-0.59353-0.5936-0.59357-1.55682 0-2.15039z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
